export default "__VITE_PUBLIC_ASSET__077b9657__"